import React, { useCallback, useEffect, useMemo, useState } from 'react'
import context from '@/context'
import propTypes from 'prop-types'
import LoadingIndicator from '@/components/LoadingIndicator'
import { ReportTable } from '@/components/report-tables'
import ErrorBoundary from '@/components/ErrorBoundary'
import { TableTools } from '@/components/reporting/tableTools'
import { useSelector } from 'react-redux'
import { EditableTableContext } from '@/components/report-tables/editable/editableTableContext'
import { actionTypes } from '@/store/ReportSubmissions'
import { ReportGroupProcessState } from '@/enums/reportGroupProcessState'

const ReportSubmissionTable = React.memo(function ReportSubmissionTable ({ readonly }) {
  const { isLoading, reportSubmission, sourceHeaders, sourceRowHeaders, sourceData, cellMetadata, scrollToRow, key, reportGroupProcessState, readOnlyFromState } =
  useSelector(state => {
    return { isLoading: state.reportSubmissions.fetching,
      reportSubmission: state.reportSubmissions.reportSubmission,
      sourceHeaders: state.reportSubmissions.sourceHeaders,
      sourceRowHeaders: state.reportSubmissions.sourceRowHeaders,
      sourceData: state.reportSubmissions.sourceData,
      cellMetadata: state.reportSubmissions.cellMetadata,
      scrollToRow: state.reportSubmissions.scrollToRow,
      key: state.reportSubmissions.reportKey,
      reportGroupProcessState: state.reportSubmissions.reportSubmission ? state.reportSubmissions.reportSubmission.reportGroupProcessState : null,
      readOnlyFromState: state.reportSubmissions.readOnly,
      activeEditor: state.reportSubmissions.activeEditor
    }
  })

  const [ isReadOnly, setIsReadOnly ] = useState(readonly)
  useEffect(() => {
    setIsReadOnly(!(reportGroupProcessState === ReportGroupProcessState.enum.Idle ||
      reportGroupProcessState === ReportGroupProcessState.enum.DataSaving ||
      reportGroupProcessState === ReportGroupProcessState.enum.DataImporting) || readonly || readOnlyFromState)
  }, [reportGroupProcessState, readonly, readOnlyFromState])

  const getSourceData = useCallback(() => { return { sourceData, cellMetadata } }, [cellMetadata, sourceData])

  const apiMethods = useMemo(() => {
    return {
      saveDataCells: context.api.reportSubmissionService.saveDataCells,
      clearReportData: context.api.reportSubmissionService.clearReportData,
      runCheckingRules: context.api.reportSubmissionService.runCheckingRules,
      getRecalculatedCells: context.api.reportSubmissionService.getRecalculatedCells
    }
  }, [])

  if (isLoading) { return <LoadingIndicator /> }
  if (reportSubmission) {
    return <EditableTableContext
      apiMethods={apiMethods}
      getSourceData={getSourceData}
      reportTable={reportSubmission}
      sourceDataDispatch={actionTypes.ReportSubmissionDataUpdated}
      submissionStatusUpdatedDispatch={actionTypes.ReportSubmissionStatusUpdated}
      submissionGroupStatusUpdatedDispatch={actionTypes.ReportSubmissionGroupStatusUpdated}
      reportSubmissonTableIsReadOnly={actionTypes.ReportSubmissonTableIsReadOnly}>
      <TableTools showPrefillFromPrevious readonly={readonly} />
      <ErrorBoundary>
        <ReportTable
          persistenceId={reportSubmission.code}
          sourceHeaders={sourceHeaders}
          sourceRowHeaders={sourceRowHeaders}
          sourceData={sourceData}
          cellMetadata={cellMetadata}
          readOnly={isReadOnly}
          scrollToRow={scrollToRow}
          defaultMetadata={{ readOnly: readonly }}
          key={key}
          blockUserInteraction={readOnlyFromState}
          commentMode={readOnlyFromState} />
      </ErrorBoundary>
    </EditableTableContext>
  }
  return null
})

ReportSubmissionTable.propTypes = {
  readonly: propTypes.bool
}

export { ReportSubmissionTable }



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/detail/reportSubmissionTable.js